export const getSubnav = (projectId: string) => (
  [
    { title: 'Categories', to: `/project/${projectId}/categories` },
    { title: 'Translations', to: `/project/${projectId}/categories/translations` },
  ]
)

